module.exports = __webpack_public_path__ + "img/scheduled.71e606e7.svg";